const TIPOS_OTP = [
  {
    label: 'Recibir código por correo electrónico',
    shortlabel: 'EMAIL',
    value: 2,
  },
  {
    label: 'Configurar autenticador móvil',
    shortlabel: 'OTP',
    value: 3,
  },
]
  
export {
  TIPOS_OTP
}
